<template>
  <div>
    <v-stepper-step :complete="current > step" :step="step" :editable="!!more" color="#FF696F" :id="`project-step-${step}`">
      Dites-nous-en un peu plus sur votre projet
    </v-stepper-step>

    <v-stepper-content :step="step">
      <h4 class="font-weight-light">Quelle zone souhaitez-vous embellir ?</h4>
      <h4 class="font-weight-light">Y a-t-il des éléments d'aménagement ou des plantes à éviter (allergies...) ?</h4>
      <h4 class="font-weight-light">Peut-on tout changer dans l'agencement de votre espace ou souhaitez-vous garder des éléments tels quels ?</h4>
      <h4 class="font-weight-bold">
        Plus vous serez précis dans la description de votre projet, plus nos experts paysagistes seront à même de comprendre vos besoins.
      </h4>
      <br/>
      <v-card >
        <v-row>
          <v-textarea
            filled
            v-model="more"
          ></v-textarea>
        </v-row>
        <v-card-actions>
          <v-btn outlined color="#0b755f" @click="$emit('change', more)" :disabled="!more">Suivant</v-btn>
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>

<script>
export default {
  model: { prop: 'data', event: 'change' },
  props: {
    data: String,
    step: Number,
    current: Number
  },
  data: () => ({
    more: ''
  }),
  beforeMount () {
    this.more = this.data
  }
}
</script>